import { Session } from '../types/types';
import { instance } from '../../../api/api';
import { HttpStatusCode } from 'axios';

/**
 * Creates a new session on the server.
 * @param token Optional authentication token for authorized sessions
 * @throws Error if session creation fails
 */
export async function startSession(token?: string): Promise<Session> {
  const { data, status } = await instance.post<Session>('/session', null, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  if (status === HttpStatusCode.Created && data) {
    return data;
  }
  throw new Error('Unable to create session');
}

/**
 * Ends a session on the server.
 * Uses the fetch API with keepalive to ensure the request completes
 * even if the page is unloading.
 */
export async function endSession(sessionId: string): Promise<void> {
  const baseApiUrl = import.meta.env.VITE_API_URL.replace(/\/$/, '');
  await fetch(`${baseApiUrl}/session/${sessionId}`, {
    method: 'DELETE',
    keepalive: true, // Ensures request completes even during page unload
  });
}

/**
 * Updates an existing session to keep it alive.
 * @throws Error if session update fails
 */
export async function updateSession(sessionId: string): Promise<Session> {
  const { data, status } = await instance.patch<Session>(
    `/session/${sessionId}`,
  );

  if (status === HttpStatusCode.Ok && data) {
    return data;
  }
  throw new Error('Unable to update session');
}
